import React, { useEffect } from "react";
import $ from "jquery";
import "magnific-popup";
import CountUp from "react-countup";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Newsletter from "../components/Newsletter";
import Breadcrumbs from "../components/Breadcrumbs"
import { useLocation } from "react-router-dom";
import StructuredData from "../seo/StructuredData";
import { breadcrumbJsonLd } from "../seo/jsonld";
import { DEFAULT_OG_IMAGE, SITE_NAME, SITE_URL } from "../seo/site";

export default function Story({ setHeader }) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const pageLang = i18n?.language === "me" ? "me" : "en";
  const pageUrl = `${SITE_URL}${location.pathname}`;
  const pageTitle = `${t("header.story.pageTitle")} - ${SITE_NAME}`;
  const pageDescription = t("header.story.metaDescription");
  const enUrl = `${SITE_URL}/en/our-story`;
  const meUrl = `${SITE_URL}/me/o-nama`;
  const breadcrumbItems = [
    { name: SITE_NAME, item: `${SITE_URL}/${pageLang}` },
    { name: t("header.story.pageTitle"), item: pageUrl },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setHeader(true);
      } else {
        setHeader(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [setHeader]);

  useEffect(() => {
    $(".popup-videos, .popup-border").magnificPopup({
      disableOn: 10,
      type: "iframe",
      title: "popup",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
    });
  }, []);

  return (
    <>
      <Helmet htmlAttributes={{ lang: pageLang === "me" ? "sr-ME" : "en" }}>
        {/* <!-- meta tag --> */}
        <meta charSet="utf-8" />
        <title>
        {pageTitle}
        </title>

        {/* <!-- Meta Tags--> */}
        <meta
          name="description"
          content={pageDescription}
        />
        <meta
          name="keywords"
          content="durō, duro, niche perfumery, niche parfimerija,  parfimerija, galerija"
        />
        <meta name="author" content="intellect.se" />
        <link rel="canonical" href={pageUrl} />
        <link rel="alternate" href={enUrl} hrefLang="en" />
        <link rel="alternate" href={meUrl} hrefLang="sr-ME" />
        <link rel="alternate" href={meUrl} hrefLang="x-default" />

        {/* <!-- responsive tag --> */}
        <meta http-equiv="x-ua-compatible" content="ie=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* <!-- Facebook Metadata --> */}
        <meta property="og:type" content="website" />
        <meta property="og:image:height" content="1200" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={DEFAULT_OG_IMAGE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:url" content={pageUrl} />
        <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
      </Helmet>
      <Loader />
      {/* <!-- Main content Start --> */}
      <div className="main-content">
        {/* <!-- Breadcrumbs Start --> */}
        <div className="rs-breadcrumbs img4">
          <div className="container">
            <div className="breadcrumbs-inner">
              <h1 className="page-title">
                {t("story.title")}
                {/*<span className="watermark">{story.title}</span>*/}
              </h1>
            </div>
          </div>
        </div>
        <Breadcrumbs/>
        {/* <!-- Breadcrumbs End --> */}

        {/* <!-- About Section Start --> */}
        <div className="rs-about style1 lion-bg pt-120 pb-120 md-pt-80 md-pb-75">
          <div className="container">
            <div className="row y-middle">
              <div className="col-lg-6 pr-15 md-pr-15 md-mb-50">
                <div className="images-part">
                  <img src="/assets/images/about/about-10.png" alt="DURŌ" />
                </div>
              </div>
              <div className="col-lg-6 pl-45 md-pl-15">
                <div className="sec-title">
                  <span className="sub-text">
                    {t("story.nichePerfumery.subText")}
                  </span>
                  <h2 className="title pb-22">{t("story.title")}</h2>
                  <div className="heading-border-line left-style"></div>
                  <p className="desc margin-0 pt-40 pb-15">
                    {t("story.nichePerfumery.desc1")}
                  </p>
                  <p className="desc margin-0 pb-15">
                    {t("story.nichePerfumery.desc2")}
                  </p>
                  <p className="desc margin-0 pb-15">
                    {t("story.nichePerfumery.desc3")}
                  </p>
                  <p className="desc margin-0 pb-15">
                    {t("story.nichePerfumery.desc4")}
                  </p>
                  <div className="rs-counter about-style">
                    <div className="row">
                      <div className="col-lg-6 md-mb-30">
                        <div className="counter-list">
                          <div className="counter-icon">
                            <img
                              src="/assets/images/counter/icons/1.png"
                              alt="Perfumes"
                            />
                          </div>
                          <div className="counter-text plus">
                            <CountUp
                              duration={2}
                              end={1200}
                              enableScrollSpy={true}
                              scrollSpyOnce={true}
                              scrollSpyDelay={2}
                              className="rs-count"
                            />
                            <h4 className="title">
                              {t("story.nichePerfumery.perfumes")}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="counter-list">
                          <div className="counter-icon">
                            <img
                              src="/assets/images/counter/icons/2.png"
                              alt="Brands"
                            />
                          </div>
                          <div className="counter-text plus">
                            <CountUp
                              delay={2}
                              duration={2}
                              end={50}
                              enableScrollSpy={true}
                              scrollSpyOnce={true}
                              scrollSpyDelay={2}
                              className="rs-count"
                            />
                            <h4 className="title">
                              {t("story.nichePerfumery.brands")}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- About Section End --> */}

        {/* <!-- Services Section Start --> */}
        <div className="rs-services style4 lion-bg pt-120 pb-120 md-pt-80 md-pb-80">
          <div className="container">
            <div className="row y-middle">
              <div className="col-lg-6 md-mb-50">
                <div className="sec-title mb-60">
                  <span className="sub-text">
                    {t("story.approach.subText")}
                  </span>
                  <h2 className="title pb-22">
                    {t("story.approach.titleBr")} <br />{" "}
                    {t("story.approach.title")}
                  </h2>
                  <div className="heading-border-line left-style"></div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <p className="desc margin-0 pb-15">
                      {t("story.approach.desc1")}
                    </p>
                    <p className="desc margin-0 pb-15">
                      {t("story.approach.desc2")}
                    </p>
                    <p className="desc margin-0 pb-15">
                      {t("story.approach.desc3")}
                    </p>
                    <p className="desc margin-0 pb-15">
                      {t("story.approach.desc4")}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 pl-50 md-pl-15">
                <div className="rs-videos choose-video">
                  <div className="images-video">
                    <img src="/assets/images/about/about-11.png" alt="DURŌ" />
                  </div>
                  <div className="animate-border">
                    <a
                      className="popup-border"
                      href="https://www.youtube.com/watch?v=rZhg7Y2CCpY"
                    >
                      <i className="fa fa-play"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Services Section End --> */}

        {/* <!-- Team Section Start --> */}
        <div className="rs-team style2 lion-bg pt-90 pb-50 md-pt-80">
          <div className="container">
            <div className="sec-title text-center mb-60">
              <span className="sub-text">{t("story.team.subText")}</span>
              <h2 className="title white-color pb-35">
                {t("story.team.title")}
              </h2>
              <div className="heading-border-line"></div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 mb-20">
                <div className="team-item">
                  <div className="team-inner-wrap">
                    <div className="images-wrap">
                      <a href="#!">
                        <img
                          src="/assets/images/about/team-1.jpg"
                          alt="Miloš R."
                        />
                      </a>
                    </div>
                    <div className="team-content">
                      <div className="rs-arrow">
                        <div className="curve"></div>
                        <div className="point"></div>
                      </div>
                      <h3 className="title-name">
                        <a href="#!">Miloš Rajović</a>
                      </h3>
                      <div className="team-title">
                        {t("story.team.founder")} &amp;<br/>
                        {t("story.team.director")}
                      </div>
                      <ul className="social-icons">
                        <li>
                          <a href="mailto:milos@duro.cologne">
                            <i className="fa fa-envelope"></i>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.instagram.com/duro_montenegro/">
                            <i className="fa-brands fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#!">
                            <i className="fa-brands fa-linkedin"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-20">
                <div className="team-item">
                  <div className="team-inner-wrap">
                    <div className="images-wrap">
                      <a href="#!">
                        <img
                          src="/assets/images/about/team-2.jpg"
                          alt="Maja Radević"
                        />
                      </a>
                    </div>
                    <div className="team-content">
                      <div className="rs-arrow">
                        <div className="curve"></div>
                        <div className="point"></div>
                      </div>
                      <h3 className="title-name">
                        <a href="#!">Maja Radević</a>
                      </h3>
                      <div className="team-title">
                       {t("story.team.manager")}<br/>
                       <span className="location">{t("story.team.porto-montenegro")}</span>
                      </div>
                      <ul className="social-icons">
                        <li>
                          <a href="mailto:info@parfimerija-duro.me">
                            <i className="fa fa-envelope"></i>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.instagram.com/majaradevic_/">
                            <i className="fa-brands fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#!">
                            <i className="fa-brands fa-linkedin"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-20">
                <div className="team-item">
                  <div className="team-inner-wrap">
                    <div className="images-wrap">
                      <a href="#!">
                        <img
                          src="/assets/images/about/team-3.jpg"
                          alt="Matija Žigić"
                        />
                      </a>
                    </div>
                    <div className="team-content">
                      <div className="rs-arrow">
                        <div className="curve"></div>
                        <div className="point"></div>
                      </div>
                      <h3 className="title-name">
                        <a href="#!">Matija Žigić</a>
                      </h3>
                      <div className="team-title">
                        {t("story.team.manager")}<br/>
                        <span className="location">{t("story.team.podgorica")}</span>
                      </div>
                      <ul className="social-icons">
                        <li>
                          <a href="mailto:info@parfimerija-duro.me">
                            <i className="fa fa-envelope"></i>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.instagram.com/matija_z/">
                            <i className="fa-brands fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a href=" ">
                            <i className="fa-brands fa-linkedin"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Team Section Start --> */}

        {/* <!-- Newsletter section start --> */}
        <div className="rs-newsletter lion-bg style1 pt-90 md-pt-60 mb--65">
          <Newsletter/>
        </div>
        {/* <!-- Newsletter section end --> */}
      </div>
      {/* <!-- Main content End --> */}
      <StructuredData data={breadcrumbJsonLd(breadcrumbItems)} />
    </>
  );
}
